import gql from 'graphql-tag'
import { fragment } from './getAppConfig'

const mutation = gql`
mutation updateAppConfig($fields: AppConfigInput!) {
	cashAssist {
		updateAppConfig(fields: $fields) {
			...generalSettings
		}
	}
}
${fragment}`
export default mutation
